/**
 * Created by chenzheyu on 2017/7/20.
 */
import XKLineSelect from './src/lineSelect.vue'

XKLineSelect.intall = function (Vue) {
  Vue.component(XKLineSelect.name, XKLineSelect)
}

export default XKLineSelect



// WEBPACK FOOTER //
// ./src/components/module/lineSelect/index.js